type FormatPrecisionOptions = {
  precision?: number
  sign?: string
}

const defaultOptions: Required<FormatPrecisionOptions> = { precision: 2, sign: '' }

export const formatPrecision = (value: string | number, { precision, sign }: FormatPrecisionOptions = defaultOptions): string | undefined => {
  return value ? `${+parseFloat(String(value)).toFixed(precision ?? defaultOptions.precision)}${sign ?? defaultOptions.sign}` : undefined
}
